import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Partner} from '../../../shared/interface/partner';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {FacilityService} from '../../../shared/services/facility.service';
import {Uuid} from '../../../shared/interface/response/uuid';
import {MatSnackBar} from '@angular/material/snack-bar';
import {catchError, mapTo, tap} from 'rxjs/operators';
import {of} from 'rxjs';
import {FormHelperService} from '../../../shared/services/form-helper.service';
import {Dictionary} from '../../../shared/interface/dictionary';
import {PARTNER_TAGS_PROFIT} from '../../../shared/services/dict.service';
import {
  PARTNER_TAGS_GOOD_AGENT,
  FACILITY_TYPE_OWN_ASF_PREMIUM,
  FACILITY_TYPE_OWN_ASF,
  FACILITY_TYPE_SELF_AGENT,
  FACILITY_TYPE_WITH_ASF_MARKETING,
  FACILITY_TYPE_SELF_GOOD_AGENT,
  DictService
} from '../../../shared/services/dict.service';


export interface FacilityAddDialogData {
  partner?: Partner;
}

@Component({
  selector: 'app-facility-add-dialog',
  templateUrl: './facility-add-dialog.component.html',
  styleUrls: ['./facility-add-dialog.component.scss']
})
export class FacilityAddDialogComponent implements OnInit {
  readonly PARTNER_TYPES = [
    FACILITY_TYPE_OWN_ASF_PREMIUM,
    FACILITY_TYPE_OWN_ASF,
    FACILITY_TYPE_SELF_AGENT,
    FACILITY_TYPE_WITH_ASF_MARKETING,
    FACILITY_TYPE_SELF_GOOD_AGENT,
  ];
  addressForm: FormGroup;
  partnerControl: FormControl;
  noteControl: FormControl;
  partnerFacilityForm: FormGroup;
  partnerObject: Partner;
  assistantDirectorControl: FormControl;
  facilityTypeControl: FormControl;
  regionalControl: FormControl;
  structureDirectorControl: FormControl;
  processingRequest = false;
  profitFacility = false;
  profitPartner = false;
  profitTag = false;

  constructor(
    public dialogRef: MatDialogRef<FacilityAddDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: FacilityAddDialogData,
    private facilityService: FacilityService,
    private snackBar: MatSnackBar,
    private fb: FormBuilder,
    private formHelper: FormHelperService,
  ) {
    this.partnerFacilityForm = this.fb.group({
      address: this.addressForm = this.formHelper.generateAddressFormGroup(),
      partners: this.partnerControl = this.fb.control([], [Validators.required]),
      note: this.noteControl = fb.control(''),
      assistantDirector: this.assistantDirectorControl = fb.control(''),
      regional: this.regionalControl = fb.control(''),
      structureDirector: this.structureDirectorControl = fb.control(''),
      facilityType: this.facilityTypeControl = fb.control('', [Validators.required]),
    });
    this.partnerObject = data.partner;
    this.profitFacility = false;
    this.profitPartner = true;
    this.profitTag = false;

    this.partnerObject.tags.forEach((tag: Dictionary) => {
      if (tag.key === PARTNER_TAGS_GOOD_AGENT) {
        this.profitTag = true;
        this.profitPartner = false;
        return;
      }
      if (tag.key === PARTNER_TAGS_PROFIT) {
        this.profitFacility = true;
        return;
      }
    });
  }

  ngOnInit(): void {
    this.partnerControl.setValue([this.partnerObject.uuid]);
  }

  createFacility(): void {
    this.processingRequest = true;
    this.facilityService
      .sendForm(this.partnerFacilityForm.getRawValue())
      .pipe(
        tap(() => this.processingRequest = false),
        tap((response: Uuid) => this.dialogRef.close(response.uuid)),
        mapTo('Pomyślnie utworzono placówkę'),
        catchError(() => {
          this.processingRequest = false;
          return of('Podczas tworzenia obiektu placówki wystąpił błąd');
        })
      )
      .subscribe((message: string) => {
        this.snackBar.open(message, '', {
          duration: 2000,
        });
      });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  copyHeadquartersAddress(): void {
    this.addressForm.reset({
      street: this.partnerObject.headquartersAddress.street,
      houseNumber: this.partnerObject.headquartersAddress.houseNumber,
      apartmentNumber: this.partnerObject.headquartersAddress.apartmentNumber,
      city: this.partnerObject.headquartersAddress.city,
      zipCode: this.partnerObject.headquartersAddress.zipCode,
      state: this.partnerObject.headquartersAddress.state?.id,
      postCity: this.partnerObject.headquartersAddress.postCity,
      district: this.partnerObject.headquartersAddress.district,
      commune: this.partnerObject.headquartersAddress.commune,
    });
  }

  copyCommunicationAddress(): void {
    this.addressForm.reset({
      street: this.partnerObject.communicationAddress.street,
      houseNumber: this.partnerObject.communicationAddress.houseNumber,
      apartmentNumber: this.partnerObject.communicationAddress.apartmentNumber,
      city: this.partnerObject.communicationAddress.city,
      zipCode: this.partnerObject.communicationAddress.zipCode,
      state: this.partnerObject.communicationAddress.state?.id,
      postCity: this.partnerObject.communicationAddress.postCity,
      district: this.partnerObject.communicationAddress.district,
      commune: this.partnerObject.communicationAddress.commune,
    });
  }
}
